import React, { useState } from "react";
import "../Delete/DeleteGroup.css";
import SuccessGroupmsg from "../SucessGroup/SuccessGroupmsg";
import axios from "../../axios";
import { IP } from "../../internalServer";

export default function DeleteGroup({ permision, list }) {
  const [click, setClick] = useState(false);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  async function cancle() {
    try {
      const res = await axios.put(`/api/v1/group/disable/${list?.id}`, {
        isDeleted: true,
      });
      res && setClick(true);
      // window.location.reload()
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      {!click && (
        <div className="deleteGroupAll">
          <div className="delete_group_sub_main  ">
            <div className="d-flex">
              <img
                style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                className="group_profile_img_member"
                src={IP + list?.profile_picture.replace(/^\./, "")}
                alt=""
              ></img>
              <div>
                <div className="class_group">{list?.name}</div>
                <div className="parent_group">{list?.description}</div>
              </div>
            </div>
            <div className="group_Deletemsg">
              Are you sure you want to delete this group?
            </div>

            <div className="btn_Yes_no_all  ">
              <div>
                <button
                  onClick={(e) => {
                    cancle();
                  }}
                  className="yes_btn_group "
                >
                  Yes
                </button>
              </div>
              <div>
                <button
                  className="No_btn_group "
                  onClick={() => permision(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
          <img
            src="/group-img/CrossIconGroup.svg"
            className="delet_icon_For_g"
            alt=""
            onClick={(e) => permision(false)}
          />
        </div>
      )}
      {click && <SuccessGroupmsg change={setClick} permision={permision} />}
    </>
  );
}
